import { Box, Typography } from '@mui/material'

export const PageDashboardInternal = () => {
  return (
    <Box padding={3} data-cy-post-login="true" data-test="main">
      <Typography variant="title1">Welcome to the dashboard</Typography>
    </Box>
  )
}
